export const  getMidRes = () => {
    let midRes = {
        "eventId":"ffffffff-9703-2de5-7417-4f0a995286bc----2bf1f277-0bde-7fb9-02fb-8e0e57ca84c8",
        "eventType":"GET_CBP_QUERY_RESPONSE",
        "eventMessage":{"detail":{"records":[{"recordId":"$1","name":"$1","values":[{"key":"mid","value":"CNDEQCHI198DEQ"}]},
        {"recordId":"$2","name":"$2","values":[{"key":"isoCountryCode","value":"CN"},{"key":"firmName","value":"DEQING CHINA-AFRICA FOREIGN TRADE PORT CO LTD"}]},
        {"recordId":"$3","name":"$3","values":[{"key":"street","value":"198 M CHANGJONG ST; 2ND FL BLDG, WUKANG"}]},
        {"recordId":"$4","name":"$4","values":[{"key":"city","value":"DEQING"}]},
        {"recordId":"$5","name":"$5"}]},
        "manufacturerDetails":{"countryCode":"CN","firmName":"DEQING CHINA-AFRICA FOREIGN TRADE PORT CO LTD","street":"198 M CHANGJONG ST; 2ND FL BLDG, WUKANG","city":"DEQING","mid":"CNDEQCHI198DEQ"}},"responseTopic":"service_event_response_ops","eventTime":1645171605201,"tenantID":"TENANT_DEFAULT","typeOfUser":"ADMINISTRATOR","userIPaddress":"103.72.10.81","userAgentname":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.80 Safari/537.36"}
        return midRes
}

export const getImporterRes = () => {
    let res = {
        "eventId": "ffffffff-9703-2de5-7417-4f0a995286bc----c8809c39-1140-2b86-02fb-8e0e57d71dec",
        "eventType": "GET_CBP_QUERY_RESPONSE",
        "eventMessage": {
            "detail": {
                "records": [{
                    "recordId": "K1",
                    "name": "K1",
                    "values": [{
                        "key": "importersName",
                        "value": "SQ ORGANIZAITON INC"
                    }, {
                        "key": "queryResultsCode",
                        "value": "2"
                    }, {
                        "key": "importerNumber",
                        "value": "46-183199900"
                    }]
                }, {
                    "recordId": "K2",
                    "name": "K2",
                    "values": [{
                        "key": "lineTwoOfImporterName",
                        "value": "TIMBERWAY BOOKS"
                    }, {
                        "key": "periodicMonthlyStatementStatus",
                        "value": "Y"
                    }, {
                        "key": "nameQualifier",
                        "value": "DBA"
                    }]
                }, {
                    "recordId": "K3",
                    "name": "K3",
                    "values": [{
                        "key": "addressLineTwo",
                        "value": "STE 207"
                    }, {
                        "key": "addressLineOne",
                        "value": "7447 HARWIN DR"
                    }]
                }, {
                    "recordId": "K4",
                    "name": "K4",
                    "values": [{
                        "key": "city",
                        "value": "HOUSTON"
                    }, {
                        "key": "postalCode",
                        "value": "770362065"
                    }, {
                        "key": "stateCode",
                        "value": "TX"
                    }]
                }, {
                    "recordId": "K5",
                    "name": "K5",
                    "values": [{
                        "key": "addressLineTwo",
                        "value": "STE 207"
                    }, {
                        "key": "addressLineOne",
                        "value": "7447 HARWIN DR"
                    }]
                }, {
                    "recordId": "K6",
                    "name": "K6",
                    "values": [{
                        "key": "city",
                        "value": "HOUSTON"
                    }, {
                        "key": "postalCode",
                        "value": "770362065"
                    }, {
                        "key": "stateCode",
                        "value": "TX"
                    }]
                }, {
                    "recordId": "K7",
                    "name": "K7",
                    "values": [{
                        "key": "centerIdentifier",
                        "value": "CEE008"
                    }, {
                        "key": "centerIDDescription",
                        "value": "CONSUMER PRODUCTS AND MASS MER"
                    }]
                }, {
                    "recordId": "K8",
                    "name": "K8",
                    "values": [{
                        "key": "additionalInformationQualifierCode",
                        "value": "IN2"
                    }, {
                        "key": "additionalInformation",
                        "value": "CHANDISING"
                    }]
                }]
            },
            "manufacturerDetails": {}
        },
        "responseTopic": "service_event_response_ops",
        "eventTime": 1645261892351,
        "tenantID": "TENANT_DEFAULT",
        "typeOfUser": "ADMINISTRATOR",
        "userIPaddress": "103.72.10.81",
        "userAgentname": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.80 Safari/537.36"
    }

    return res;

}